/** @flow */

import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { localize } from "redux-i18n";
import { ColumnsContainer } from "@components";
import { formatDate } from "@transformers/date";
import { getAbsenceReasonsLabels } from "@modules/shared/selectors/absence-reasons";
import { getStaffGroupsLabels } from "@modules/shared/selectors/staff-groups";
import type { State } from "@store/reducers";

type OwnProps = $Exact<{
  data: Object,
}>;

type PropsFromState = $Exact<{
  absenceReasons: string,
  staffGroups: string,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromLocalize,
}>;

export class StepFiltersView extends React.Component<Props> {
  get filtersOptions() {
    return [
      {
        columns: [
          {
            data: [
              [
                this.props.t("REPORT_FILTER_DATE_RANGE"),
                this.props.data.dateRange
                  ? this.props.t(this.props.data.dateRange)
                  : this.props.t("CUSTOM"),
              ],
              [
                this.props.t("ABSENCES_FILTER"),
                this.props.data.absencesFilter
                  ? this.props.t(this.props.data.absencesFilter)
                  : this.props.t("ALL"),
              ],
              [
                this.props.t("ABSENCE_STATUS"),
                this.props.data.absenceStatus
                  ? this.props.t(this.props.data.absenceStatus)
                  : this.props.t("ALL"),
              ],
              [
                this.props.t("ABSENCES_GREATER_THAN_DAY_TYPE"),
                this.props.data.absencesGreaterThanDayType
                  ? this.props.t(this.props.data.absencesGreaterThanDayType)
                  : this.props.t("ALL"),
              ],
              [
                this.props.t("INCLUDE_EMPLOYEES_WITH_DISABILITY"),
                this.props.data.includeEmployeesWithDisability
                  ? this.props.t("YES")
                  : this.props.t("NO"),
              ],
              [
                this.props.t("AGE_GROUPS"),
                (this.props.data.ageGroups || [])
                  .map(ageGroup => this.props.t(ageGroup))
                  .join(", "),
              ],
            ],
          },
          {
            data: [
              [
                this.props.t("FROM_DATE"),
                this.props.data.fromDate ? formatDate(this.props.data.fromDate) : "",
              ],
              [
                this.props.t("ABSENCE_TYPE"),
                this.props.data.absenceType
                  ? this.props.t(this.props.data.absenceType)
                  : this.props.t("ALL"),
              ],
              [
                this.props.t("REPORT_FILTER_ABSENCE_LENGTH"),
                this.props.data.absenceLength
                  ? this.props.t(this.props.data.absenceLength)
                  : this.props.t("ALL"),
              ],
              [
                this.props.t("GENDER"),
                this.props.data.gender ? this.props.t(this.props.data.gender) : this.props.t("ALL"),
              ],
              [this.props.t("ABSENCE_REASONS"), this.props.absenceReasons],
            ],
          },
          {
            data: [
              [
                this.props.t("TO_DATE"),
                this.props.data.toDate ? formatDate(this.props.data.toDate) : "",
              ],
              [
                this.props.t("SHOW_WORK_RELATED_ONLY"),
                this.props.data.showWorkRelatedOnly ? this.props.t("YES") : this.props.t("NO"),
              ],
              [
                this.props.t("ABSENCES_GREATER_THAN_DAYS"),
                this.props.data.absencesGreaterThanDays || this.props.t("ALL"),
              ],
              [
                this.props.t("INCLUDE_LEAVERS"),
                this.props.data.includeLeavers ? this.props.t("YES") : this.props.t("NO"),
              ],
              [this.props.t("STAFF_GROUPS"), this.props.staffGroups],
            ],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer className="w-100" rows={this.filtersOptions} />;
  }
}

const mapStateToProps = (state: State, ownProps: OwnProps): PropsFromState => ({
  absenceReasons: getAbsenceReasonsLabels(
    state,
    (ownProps.data.absenceReasons || []).map(absenceReason => absenceReason.id),
  ),
  staffGroups: getStaffGroupsLabels(
    state,
    (ownProps.data.staffGroups || []).map(staffGroup => staffGroup.id),
  ),
});

export default compose(connect(mapStateToProps, null), localize())(StepFiltersView);
